<main class="text-start">
  <h2 class="page-title"> <i [routerLink]="['/orders']" class="bi text-[#8A8AA3] text-sm cursor-pointer" [class.bi-chevron-right]="languageService.isRtl()" [class.bi-chevron-left]="!languageService.isRtl()"></i> <a [routerLink]="['/orders']" class="text-[#8A8AA3] me-0.5 ms-2">{{ 'orders.details.back' | translate }} </a> {{ 'orders.details.title' | translate }}</h2>

  <div *ngIf="order" class="bg-[#F6F6F6] rounded-md p-3.5 flex items-start max-xl:flex-col xl:flex-row-reverse max-xl:items-center gap-5">
    <!-- LEFT: driver + recipient -->
    <div class="max-xl:w-full w-2/7 h-fit">

      <!-- Delivery driver panel -->
      <div class="w-full bg-white rounded-xl px-5 py-5 border-t-8 border-[#611F79]">
        <p class="text-[#1F1F1F] font-semibold text-[0.8rem] mb-3">{{ 'orders.details.driver.title' | translate }}</p>

        <!-- Assigned driver -->
        <div *ngIf="order.assigned_driver && !showDriverPicker" class="flex items-center gap-3">
          <div class="bg-[#EDE7F6] w-10 h-10 rounded-full overflow-hidden flex items-center justify-center shrink-0">
            <img *ngIf="order.assigned_driver.profile_image; else driverIcon" [src]="order.assigned_driver.profile_image" class="w-10 h-10 object-cover" alt="">
            <ng-template #driverIcon><i class="bi bi-person-badge text-[#611F79]"></i></ng-template>
          </div>
          <div class="flex-1">
            <p class="text-sm text-[#2F3541] font-medium">{{ order.assigned_driver.name }}</p>
            <a *ngIf="telLink(order.assigned_driver.phone_number) as tel" [href]="tel" class="text-xs text-[#1A56DB] inline-flex items-center gap-1" dir="ltr"><i class="bi bi-telephone-fill"></i> {{ order.assigned_driver.phone_number }}</a>
          </div>
        </div>
        <div *ngIf="order.assigned_driver && !showDriverPicker && !isFinalized" class="flex gap-2 mt-3">
          <button (click)="openPicker()" class="text-xs border border-[#D1D1DB] rounded-md px-3 py-1.5 cursor-pointer">{{ 'orders.details.driver.change' | translate }}</button>
          <button (click)="unassign()" [disabled]="assigning" class="text-xs border border-red-200 text-red-600 rounded-md px-3 py-1.5 cursor-pointer disabled:opacity-50">{{ 'orders.details.driver.unassign' | translate }}</button>
        </div>

        <!-- No driver yet -->
        <div *ngIf="!order.assigned_driver && !showDriverPicker" class="flex flex-col gap-3">
          <span class="inline-flex items-center gap-1 w-fit py-1 px-2.5 rounded-full text-[0.7rem] font-medium bg-amber-50 text-amber-600 border border-amber-200"><i class="bi bi-exclamation-circle"></i> {{ 'orders.unassigned_driver' | translate }}</span>
          <button *ngIf="!isFinalized" (click)="openPicker()" class="text-xs bg-[#611F79] text-white rounded-md px-3 py-1.5 cursor-pointer w-fit inline-flex items-center"><i class="bi bi-person-plus-fill me-1"></i> {{ 'orders.details.driver.assign' | translate }}</button>
        </div>

        <!-- Driver picker -->
        <div *ngIf="showDriverPicker" class="flex flex-col gap-3">
          <select [(ngModel)]="selectedDriverId" class="border border-[#D1D1DB] rounded-md px-2 py-2 text-xs w-full">
            <option [ngValue]="null" disabled>{{ 'orders.details.driver.select_placeholder' | translate }}</option>
            <option *ngFor="let d of drivers" [ngValue]="d.id">{{ d.name }} ({{ d.assigned_deliveries_count }})</option>
          </select>
          <div class="flex gap-2">
            <button (click)="confirmAssign()" [disabled]="assigning || selectedDriverId == null" class="text-xs bg-[#611F79] text-white rounded-md px-3 py-1.5 cursor-pointer disabled:opacity-50">{{ 'orders.details.driver.confirm' | translate }}</button>
            <button (click)="cancelPicker()" [disabled]="assigning" class="text-xs border border-[#D1D1DB] rounded-md px-3 py-1.5 cursor-pointer">{{ 'orders.details.driver.cancel' | translate }}</button>
          </div>
          <p class="text-[0.65rem] text-[#8E8E8E]">{{ 'orders.details.driver.load_hint' | translate }}</p>
        </div>
      </div>

      <!-- Recipient details -->
      <div class="w-full bg-white rounded-xl mt-3 px-5 py-5">
        <p class="text-[#1F1F1F] font-semibold text-[0.8rem]">{{ 'orders.details.recipient_details' | translate }}</p>

        <div class="p-3 flex justify-between items-center gap-2">
          <div class="flex items-center gap-2">
            <div class="bg-[#FCC5F3] w-8 h-8 rounded-full">
              <img src="dashboard/place-holders/avatar-female.png" class="w-8 h-8 rounded-full" alt="">
            </div>
            <span class="text-[#2F3541] text-sm"> {{ order.recipient_name }} </span>
          </div>
          <a *ngIf="telLink(order.recipient_phone_number) as tel" [href]="tel"
            class="bi bi-telephone-fill w-8 h-8 rounded-full flex justify-center items-center bg-[#1A56DB33] text-[#1A56DB] no-underline"></a>
        </div>

        <div class="w-full h-[2px] px-3 mb-2 mt-1 bg-[#E4E4E499]"></div>

        <div class="flex flex-col">
          <div class="flex justify-between items-center mt-1.5 mb-2.5">
            <span class="text-[#2F3541] text-[0.8rem]"> {{ 'orders.details.address_section' | translate }} </span>
            <a *ngIf="mapsLink(order.recipient_latitude, order.recipient_longitude) as ml" [href]="ml" target="_blank"
              class="text-xs text-[#1A56DB] inline-flex items-center gap-1"><i class="bi bi-geo-alt-fill"></i> {{ 'orders.details.open_in_maps' | translate }}</a>
          </div>

          <app-google-map *ngIf="order.recipient_latitude && order.recipient_longitude"
            [latitude]="order.recipient_latitude" [longitude]="order.recipient_longitude" [zoom]="13"
            markerTitle="delivery address"></app-google-map>

          <div class="flex flex-col mt-2.5 text-[0.8rem]">
            <span class="text-[#2F3541] text-[0.8rem]"> {{ order.recipient_state }}, {{ order.recipient_city }} </span>
            <span class="text-[#2F3541] text-[0.8rem]"> {{ order.recipient_street1 }} </span>
          </div>
        </div>
      </div>
    </div>

    <!-- RIGHT: order body -->
    <div class="bg-white max-xl:w-full w-5/7 rounded-xl px-5 py-5 -space-y-0.5">

      <div class="w-full flex max-md:flex-col justify-between md:items-center items-start gap-2 md:gap-0 text-sm">
        <div class="header-container">
          <p class="header-details">{{ 'orders.details.header.invoice_number' | translate }}</p>
          <p class="header-sub-details">#{{ order.order_uuid | slice:0:8 }}</p>
        </div>

        <div class="header-container">
          <p class="header-details">{{ 'orders.details.header.placed_at' | translate }}</p>
          <p class="header-sub-details" dir="ltr">{{ order.placed_at | date: 'dd MMM / hh:mm a' }}</p>
        </div>

        <div class="header-container">
          <p class="header-details">{{ 'orders.details.header.expected_delivery' | translate }}</p>
          <p class="header-sub-details" dir="ltr">{{ expectedDelivery() ? (expectedDelivery() | date: 'dd MMM') : '—' }}</p>
        </div>

        <div class="header-container">
          <p class="header-details">{{ 'orders.details.header.status' | translate }}</p>
          <p [ngClass]="{
                  'bg-purple-100 text-purple-700': order.status === 'preparing_order',
                  'bg-blue-100 text-blue-700': order.status === 'placed',
                  'bg-emerald-100 text-emerald-700': order.status === 'ready_for_pickup',
                  'bg-yellow-100 text-yellow-700': order.status === 'out_for_delivery',
                  'bg-green-100 text-green-700': order.status === 'delivered',
                  'bg-red-100 text-red-700': order.status === 'cancelled' || order.status === 'rejected',
                  'bg-rose-100 text-rose-700': order.status === 'refunded'
                }" class="py-1 px-2 rounded-md text-[10px] font-medium text-xs">
            {{ ('orders.statuses.' + order.status) | translate }}
          </p>
        </div>
      </div>

      <!-- Terminal state banner -->
      <div *ngIf="isCancelledOrRefunded" class="bg-[#FEF2F2] border-s-2 border-red-400 p-3.5 mt-8 text-xs text-red-700 flex items-center gap-2">
        <i class="bi bi-exclamation-octagon-fill"></i>
        {{ ('orders.details.terminal.' + order.status) | translate }}
      </div>

      <!-- Progress tracker -->
      <div *ngIf="!isCancelledOrRefunded" class="flex flex-col gap-3 mt-8">
        <p class="font-semibold text-[#4B4B4B] text-xs">{{ 'orders.details.progress.section_title' | translate }}</p>
        <div class="border-[1.5px] border-[#ededed] rounded-lg flex max-md:flex-col items-center gap-3.5 justify-center w-full px-4 py-4">
          <div class="max-md:w-full w-1/4 text-xs">
            <p class="ms-1 flex items-center justify-start gap-1 text-gray-600"> <i class="bi bi-alarm text-sm me-1.5"></i> {{ 'orders.details.progress.placed' | translate }}</p>
            <div class="h-2 w-full bg-[#EBEBEF] rounded-full mt-2.5 overflow-hidden relative">
              <div class="h-full rounded-full absolute top-0 start-0 transition-all duration-500"
                [ngClass]="order.status === 'placed' ? 'bg-blue-500' : 'bg-green-500'" [style.width.%]="100"></div>
            </div>
          </div>
          <div class="max-md:w-full w-1/4 text-xs">
            <p class="ms-1 flex items-center justify-start gap-1 text-gray-600"> <i class="bi bi-box2 text-sm me-1.5"></i> {{ 'orders.details.progress.preparing_order' | translate }}</p>
            <div class="h-2 w-full bg-[#EBEBEF] rounded-full mt-2.5 overflow-hidden relative">
              <div class="h-full rounded-full absolute top-0 start-0 transition-all duration-500"
                [ngClass]="order.status === 'preparing_order' ? 'bg-blue-500' : order.status === 'ready_for_pickup' || order.status === 'out_for_delivery' || order.status === 'delivered' ? 'bg-green-500' : ''"
                [style.width.%]="100"></div>
            </div>
          </div>
          <div class="max-md:w-full w-1/4 text-xs">
            <p class="ms-1 flex items-center justify-start gap-1 text-gray-600"> <i class="bi bi-box2-heart text-sm me-1.5"></i> {{ 'orders.details.progress.ready_for_pickup' | translate }}</p>
            <div class="h-2 w-full bg-[#EBEBEF] rounded-full mt-2.5 overflow-hidden relative">
              <div class="h-full rounded-full absolute top-0 start-0 transition-all duration-500"
                [ngClass]="order.status === 'ready_for_pickup' ? 'bg-blue-500' : order.status === 'out_for_delivery' || order.status === 'delivered' ? 'bg-green-500' : ''"
                [style.width.%]="100"></div>
            </div>
          </div>
          <div class="max-md:w-full w-1/4 text-xs">
            <p class="ms-1 flex items-center justify-start gap-1 text-gray-600"> <i class="bi bi-truck text-sm me-1.5"></i> {{ 'orders.details.progress.out_for_delivery' | translate }}</p>
            <div class="h-2 w-full bg-[#EBEBEF] rounded-full mt-2.5 overflow-hidden relative">
              <div class="h-full rounded-full absolute top-0 start-0 transition-all duration-500"
                [ngClass]="order.status === 'out_for_delivery' ? 'bg-blue-500' : order.status === 'delivered' ? 'bg-green-500' : ''"
                [style.width.%]="100"></div>
            </div>
          </div>
          <div class="max-md:w-full w-1/4 text-xs">
            <p class="ms-1 flex items-center justify-start gap-1 text-gray-600"> <i class="bi bi-clipboard-check text-sm me-1.5"></i> {{ 'orders.details.progress.delivered' | translate }}</p>
            <div class="h-2 w-full bg-[#EBEBEF] rounded-full mt-2.5 overflow-hidden relative">
              <div class="h-full rounded-full absolute top-0 start-0 transition-all duration-500"
                [ngClass]="order.status === 'delivered' ? 'bg-green-500':''" [style.width.%]="100"></div>
            </div>
          </div>
        </div>
      </div>

      <!-- Pickup points (grouped by vendor) -->
      <div class="font-semibold text-[#4B4B4B] my-3 flex justify-start items-center gap-2 mt-8 text-xs">
        <div>{{ 'orders.details.pickup_points_count' | translate }}</div>
        <div>{{ order.vendors.length }}</div>
      </div>

      <div class="flex flex-col gap-3 mb-3.5">
        <div *ngFor="let ov of order.vendors" class="w-full bg-white border border-[#ededed] rounded-lg p-3 flex flex-col gap-3">
          <div class="w-full flex justify-between items-center gap-3">
            <div class="flex items-center gap-3">
              <img [src]="ov.vendor.logo || 'dashboard/place-holders/product-1.png'" class="w-9 h-9 rounded object-cover" alt="">
              <div>
                <p class="text-xs font-medium">{{ ov.vendor.shop_name }}</p>
                <p class="text-[0.7rem] text-[#6B7280]">{{ ov.vendor.neighborhood }}</p>
              </div>
            </div>
            <div class="flex items-center gap-2">
              <span class="inline-block py-1 px-2.5 rounded-full text-[0.7rem] font-medium text-nowrap"
                [ngClass]="ov.status === 'ready_for_pickup' ? 'bg-green-100 text-green-700' : ov.status === 'rejected' ? 'bg-red-100 text-red-700' : ov.status === 'preparing_order' ? 'bg-purple-100 text-purple-700' : 'bg-blue-100 text-blue-700'">
                {{ ('orders.statuses.' + ov.status) | translate }}
              </span>
              <a *ngIf="telLink(ov.vendor.phone_number) as tel" [href]="tel"
                class="bi bi-telephone-fill w-8 h-8 rounded-full flex justify-center items-center bg-[#1A56DB33] text-[#1A56DB] no-underline"></a>
              <a *ngIf="mapsLink(ov.vendor.latitude, ov.vendor.longitude) as ml" [href]="ml" target="_blank"
                class="bi bi-geo-alt-fill w-8 h-8 rounded-full flex justify-center items-center bg-[#DB1A1D33] text-[#DB1A1D] no-underline"></a>
            </div>
          </div>
          <div class="border-t border-[#f0f0f0] pt-2 flex flex-col gap-2">
            <div *ngFor="let item of itemsForVendor(ov.vendor.id)" class="flex justify-between items-start gap-2 text-[0.72rem] text-[#2F3541]">
              <div class="flex flex-col">
                <span class="font-medium">{{ item.product_name || item.variant.name }}</span>
                <span *ngIf="item.product_name && item.variant.name !== item.product_name" class="text-[#6B7280] text-[0.66rem]">{{ item.variant.name }}</span>
              </div>
              <span class="inline-block bg-gray-100 text-gray-700 px-1.5 py-0.5 rounded shrink-0">{{ item.quantity }}x</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Summary -->
      <p class="font-semibold text-[#4B4B4B] mt-8 text-xs">{{ 'orders.details.summary' | translate }}</p>
      <div class="bg-[#F5F5F5] p-3.5 rounded-lg mt-3.5 text-xs">
        <div *ngFor="let item of order.items" class="flex justify-between items-start gap-2 text-[#2F3541] text-xs mb-5">
          <p class="text-xs text-[#2F3541] font-medium flex items-start gap-2">
            <span>
              {{ item.product_name || item.variant.name }}
              <span *ngIf="item.product_name && item.variant.name !== item.product_name" class="text-[#6B7280] font-normal">— {{ item.variant.name }}</span>
            </span>
            <span class="inline-block bg-gray-200 text-gray-700 px-2 py-0.5 rounded-md text-xs font-semibold shrink-0">
              {{ item.quantity }} x
            </span>
          </p>
          <p class="shrink-0">{{ item.price * item.quantity }} {{ 'common.currency' | translate }}</p>
        </div>

        <div class="flex justify-between items-center text-[#363636] font-semibold text-xs">
          <p>{{ 'orders.details.total' | translate }}</p>
          <p>{{ totalOrderPrice }} {{ 'common.currency' | translate }}</p>
        </div>
      </div>

      <!-- Assignment history -->
      <div *ngIf="assignmentHistory.length" class="mt-8">
        <p class="font-semibold text-[#4B4B4B] text-xs mb-3">{{ 'orders.details.assignment_history' | translate }}</p>
        <div class="flex flex-col gap-2">
          <div *ngFor="let log of assignmentHistory" class="flex items-center gap-2 text-[0.7rem] text-[#6C6C89]">
            <i class="bi" [ngClass]="{ 'bi-person-check text-green-600': log.action === 'assigned' || log.action === 'reassigned', 'bi-person-dash text-red-500': log.action === 'unassigned' }"></i>
            <span>{{ ('orders.details.driver_actions.' + log.action) | translate }}</span>
            <span class="font-medium text-[#2F3541]">{{ log.driver_name }}</span>
            <span *ngIf="log.assigned_by_name">· {{ log.assigned_by_name }}</span>
            <span dir="ltr" class="ms-auto">{{ log.created_at | date: 'dd MMM / hh:mm a' }}</span>
          </div>
        </div>
      </div>

    </div>
  </div>
</main>
